const capitalizeFirstLetterOfAString = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const capitalizeFirstLettersOfString = (str) => {
    if (!str) return '';
    return str.split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

const toTitleCase = (str) => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

// Helper function to format the email address: title case before the @ symbol.
const formatEmail = (email) => {
    if (!email) return email;
    const [local, domain] = email.split("@");
    // If the local-part has multiple segments (e.g., separated by dots), convert each segment.
    const formattedLocal = local
        .split(".")
        .map((segment) => toTitleCase(segment))
        .join(".");
    return `${formattedLocal}@${domain}`;
};

function formatPhoneNumber(raw = "") {
    const digits = raw.replace(/\D/g, "");
    const match = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return raw;
  }

export { capitalizeFirstLetterOfAString, capitalizeFirstLettersOfString, toTitleCase, formatEmail, formatPhoneNumber };